import { Formik } from 'formik';
import * as yup from 'yup';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './../style/change-password.css';
import { changePassword } from '../services/userService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

const ChangePassword = () => {
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const passwordSchema = yup.object().shape({
    oldPassword: yup.string().required('Current password is required'),
    newPassword: yup
      .string()
      .min(8, 'Password must be at least 8 characters')
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        'Password must contain at least one special character'
      )
      .required('New password is required'),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
      .required('Confirm password is required'),
  });

  const handlePasswordSubmit = async (data) => {
    changePassword(data);
  };

  return (
    <section className="d-flex justify-content-center align-items-center change-password__container">
      <div className="card p-4 shadow" style={{ width: "60%" }}>
        <h3 className="text-center mb-4">Spremeni geslo</h3>
        <Formik
          validationSchema={passwordSchema}
          onSubmit={handlePasswordSubmit}
          initialValues={{
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
          }}
        >
          {({ handleSubmit, handleChange, values, errors }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Form.Group controlId="currentPassword" className="mb-3">
                <Form.Label>Trenutno geslo</Form.Label>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showOldPassword ? "text" : "password"}
                    placeholder="Vnesite trenutno geslo"
                    name="oldPassword"
                    value={values.oldPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.oldPassword}
                  />
                  <FontAwesomeIcon
                    icon={showOldPassword ? faEyeSlash : faEye}
                    onClick={() => setShowOldPassword(!showOldPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: errors.oldPassword ? "30%" : "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.oldPassword}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <Form.Group controlId="newPassword" className="mb-3">
                <Form.Label>Novo geslo</Form.Label>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showNewPassword ? "text" : "password"}
                    placeholder="Vnesite novo geslo"
                    name="newPassword"
                    value={values.newPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.newPassword}
                  />
                  <FontAwesomeIcon
                    icon={showNewPassword ? faEyeSlash : faEye}
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: errors.newPassword ? "30%" : "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.newPassword}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <Form.Group controlId="confirmPassword" className="mb-3">
                <Form.Label>Potrdi novo geslo</Form.Label>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Potrdi novo geslo"
                    name="confirmPassword"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    isInvalid={!!errors.confirmPassword}
                  />
                  <FontAwesomeIcon
                    icon={showConfirmPassword ? faEyeSlash : faEye}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: errors.confirmPassword ? "30%" : "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6c757d",
                    }}
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.confirmPassword}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <Button
                type="submit"
                variant="primary"
                className="w-100 !bg-custom-green"
              >
                Spremeni geslo
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default ChangePassword;
